import { IFeedTeam } from '@/types';

export function useSearchedTeamIds(search: Ref<string>, teamItems: Ref<Record<number, IFeedTeam>>) {
    const searchedTeamIds = computed<number[] | null>(() => {
        if (!search.value) {
            return null;
        }

        const searchLower = search.value.toLowerCase();
        const result: number[] = [];

        for (const id in teamItems.value) {
            const team = teamItems.value[id];
            if (team.name.toLowerCase().includes(searchLower)) {
                result.push(team.id);
            }
        }

        return result;
    });

    return { searchedTeamIds };
}
